// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"491":"e6c815a98bf0addb","845":"5e9d86cee8e77cfa"}[chunkId] + ".js";
};